import React from 'react';
import { useTranslation } from 'react-i18next';
import { Active } from 'types';
import { CloseProductSection } from '../../components/CloseProductSection';
import { useCloseConfigureModal } from '../../hooks/useCloseConfigureModal';
import { useCloseServiceAgreement } from '../../hooks/useCloseServiceAgreement';
import { useGenericCloseBodyText } from '../../hooks/useGenericCloseBodyText';
import { ConfigureProductDialog } from '../../shell/ConfigureProductDialog';
import type { ConfigureProductGroupModalProps } from '../configureProductGroupModalProps';

const MODAL_WIDTH = '540px';

export const SimpleProductModal: React.FC<ConfigureProductGroupModalProps> = ({ serviceAgreement, brUid }) => {
  const { t } = useTranslation();
  const { close, isClosing } = useCloseServiceAgreement(serviceAgreement, brUid);
  const closeBodyText = useGenericCloseBodyText();
  const handleClose = useCloseConfigureModal(false);
  const showCloseProductSection = serviceAgreement.agreementStatus !== Active.ACTIVE;

  return (
    <ConfigureProductDialog
      title={t('pb.configureproductmodal.title', 'Edit product')}
      width={MODAL_WIDTH}
      size="small"
      isPending={false}
      onClose={handleClose}
      footer={{ canSave: false, saveBlockedReasons: [], showSave: false }}
    >
      {showCloseProductSection && (
        <CloseProductSection
          isPending={false}
          bodyText={closeBodyText}
          addTopMargin={false}
          isClosing={isClosing}
          onConfirmClose={close}
        />
      )}
    </ConfigureProductDialog>
  );
};
